import { render } from "./ScorecardDialog.vue?vue&type=template&id=0d8a4a00&scoped=true"
import script from "./ScorecardDialog.vue?vue&type=script&lang=js"
export * from "./ScorecardDialog.vue?vue&type=script&lang=js"

import "./ScorecardDialog.vue?vue&type=style&index=0&id=0d8a4a00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8a4a00"]])

export default __exports__